import logoImage from "../../assest/images/logo-img.png"
import backgroundImg from "../../assest/images/signupbg3.jpg"
import backgroundImgDark from "../../assest/images/signupbg_dark.jpg"

import { Link } from "react-router-dom"
import LastBox from "../../components/LastBox"
import IntlTelInput from "intl-tel-input/reactWithUtils";
import "intl-tel-input/styles"
// import 'intl-tel-input/build/css/intlTelInput.css';
import ReCAPTCHA from 'react-google-recaptcha';
import whiteLogoImage from "../../assest/images/whitelogo.png";
import { useSelector } from "react-redux"





const Index = ({
    state,
    register,
    changeValue,
    showPassword, showCPassword,
    handhandleShowPassword,
    inputRef,
    getClassNames,
    setRecaptchaToken,
    isLoading,
    handleNumberChange,
    handleValidityChange,
    initialCountry,
    geoIpLookup,
    isSamePass,
    resetRecaptcha,
    recaptchaRef,
    userlang
}) => {
    const user = useSelector((state) => state.user);
    const isDark = user.isDarkMode;

    const { first_name, last_name, error, email, password, cpassword, phone } = state;

    return (
        <section className="loginSec signUp" style={{ backgroundImage: `url(${isDark ? backgroundImgDark : backgroundImg})` }}>
            <div className="loginpart">
                <div className="container">
                    <div className="loginBox">
                        <div className="logoSec">
                            <Link to={'/' + userlang} className='comLogo'>
                                <img src={logoImage} alt="logo-img" />
                            </Link>
                            <Link to={'/' + userlang} className='whitelogo'><img src={whiteLogoImage} alt="logo-img" /></Link>
                            <h4>Join Toursxplorer.com</h4>
                        </div>
                        <form onSubmit={register}>
                            <div className="fillDetails">
                                <div className="nameBox">
                                    <div className="box-box">
                                        <label className="commonLabel" htmlFor="">First Name</label>
                                        <input className="commonInput" name="first_name" type="text" placeholder="Enter First name" value={first_name} onChange={changeValue} />
                                        {error && error.first_name && <span className="cus-err">{error.first_name}</span>}

                                    </div>
                                    <div className="box-box">
                                        <label className="commonLabel" htmlFor="">Last Name</label>
                                        <input
                                            className="commonInput"
                                            type="text"
                                            placeholder="Enter Last name"
                                            name="last_name"
                                            value={last_name}
                                            onChange={changeValue}
                                        />
                                        {error && error.last_name && <span className="cus-err">{error.last_name}</span>}

                                    </div>
                                </div>
                                <ul>
                                    <li>
                                        <label className="commonLabel" htmlFor="email">Email</label>
                                        <input
                                            className="commonInput"
                                            type="email"
                                            placeholder="Enter Email"
                                            name="email"
                                            value={email}
                                            onChange={changeValue}
                                        />
                                        {error && error.email && <span className="cus-err">{error.email}</span>}

                                    </li>
                                    <li>
                                        <label className="commonLabel" htmlFor="phone">Phone</label>
                                        {/* <input id="phone" className="commonInput" type="tel" ref={inputRef} /> */}
                                        <div>
                                            <IntlTelInput
                                                ref={inputRef}
                                                initialValue={''}
                                                onChangeNumber={(e) => handleNumberChange(e)}
                                                onChangeValidity={(e) => handleValidityChange(e)}
                                                // formatOnDisplay={false}
                                                showFlags={true}
                                                initOptions={{
                                                    initialCountry: 'auto',
                                                    separateDialCode: true,
                                                    geoIpLookup: geoIpLookup,
                                                }}

                                            />
                                            {error && error.country_code && <span className="cus-err mt-1">{error.country_code}</span>}

                                        </div>
                                    </li>
                                    {/* <li className="countryBox">
                                    <div className="contryCode">
                                        <label className="commonLabel" htmlFor="">COUNTRY</label>
                                        <div className="dropdown">
                                            <button className="dropbtn" id="selectedCountry">
                                                <img src="assest/images/uzabkist.png" alt="Flag of Uzbekistan" className="flag-icon" id="currentFlag" />
                                                +998
                                                <span className="arrow-up"><i className="fa-solid fa-chevron-down"></i></span>
                                            </button>
                                            <div className="dropdown-content">
                                                <a href="javascript:void(0)" onclick="selectCountry('india.png', '+91')">
                                                    <img src="assest/images/india.png" alt="Flag of India" className="flag-icon" /> +91
                                                </a>
                                                <a href="javascript:void(0)" onclick="selectCountry('uzabkist.png', '+998')">
                                                    <img src="assest/images/uzabkist.png" alt="Flag of Uzbekistan" className="flag-icon" /> +998
                                                </a>
                                                <a href="javascript:void(0)" onclick="selectCountry('usa.png', '+1')">
                                                </a>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="mobilNum">
                                        <label className="commonLabel" htmlFor="">NUMBER</label>
                                        <input className="commonInput" type="email" placeholder="" />
                                    </div>
                                </li> */}
                                    <li className="mt-3">
                                        <label className="commonLabel" htmlFor="">Password</label>
                                        <input
                                            className={"commonInput " + getClassNames(2)}
                                            type={!showPassword ? 'password' : 'text'}
                                            placeholder="Enter Pasword"
                                            name="password"
                                            value={password}
                                            onChange={changeValue}
                                        />
                                        <button className="btn btnShow" type="button">

                                            {
                                                showPassword ? <i className="fa-solid fa-eye-slash" onClick={(e) => handhandleShowPassword(e, 1)}></i> : <i className="fa-solid fa-eye" onClick={(e) => handhandleShowPassword(e, 1)}></i>
                                            }
                                        </button>
                                        {error && error.password && <span className="cus-err">{error.password}</span>}

                                    </li>
                                    <li>
                                        <div className="lineSpan">
                                            <span className={getClassNames(0)}></span>
                                            <span className={getClassNames(1)}></span>
                                            <span className={getClassNames(2)}></span>
                                        </div>
                                    </li>
                                    <li>
                                        <label className="commonLabel" htmlFor="">Password</label>
                                        <input
                                            className={isSamePass ? "commonInput greenSpan" : "commonInput"}
                                            type={!showCPassword ? 'password' : 'text'}
                                            placeholder="Re-Enter Pasword"
                                            name="cpassword"
                                            value={cpassword}
                                            onChange={changeValue}
                                        />
                                        <button className="btn btnShow" type="button">
                                            {
                                                showCPassword ? <i className="fa-solid fa-eye-slash" onClick={(e) => handhandleShowPassword(e, 0)}></i> : <i className="fa-solid fa-eye" onClick={(e) => handhandleShowPassword(e, 0)}></i>
                                            }
                                        </button>
                                        {error && error.cpassword && <span className="cus-err">{error.cpassword}</span>}

                                    </li>
                                    <li>
                                        {/* <div className="reg-g-captcha-main"> */}
                                        {/* <div className="g-recaptcha" ref={recaptchaRef}></div> */}

                                        {/* <ReCAPTCHA
                                                ref={recaptchaRef}
                                                sitekey={process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY}
                                                onChange={(token) => setRecaptchaToken(token)}
                                                onExpired={(e) => resetRecaptcha(e)}
                                            // onErrored={() => resetRecaptcha()}
                                            /> */}
                                        {/* {error && error.recaptchaToken && <span className="cus-err mt-1">{error.recaptchaToken}</span>} */}
                                        {/* </div> */}
                                    </li>
                                </ul>
                                <div className="remember">
                                    <div className="loginBtn">
                                        <button
                                            className="btn common-btn btn-login"
                                            type="submit"
                                            disabled={isLoading}
                                        >
                                            {isLoading ? "Loading..." : "Confirm"}
                                            {!isLoading && <i className="fa-solid fa-chevron-right"></i>}

                                        </button>
                                    </div>
                                    <div className="register">
                                        <p>Already have an account? <Link className="comYellowa" to={'/' + userlang + '/login'}>Log in</Link></p>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <LastBox  userlang={userlang} />
                </div>
            </div>
        </section>
    )
}
export default Index;